import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { clickMenuOpen } from "../../../../redux/actions";
import servicioUsuario from "../../../../servicios/servicioUsuario";
import Autenticador from "../../../../servicios/Autenticador";

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: "",
      entidad: "",
    };
  }

  async componentDidMount() {
    const usuario = await servicioUsuario.obtenerUsuarioDelSistema();

    this.setState({
      nombre: usuario.persona.nombreCompleto,
      entidad: usuario.entidad.alias,
    });
  }

  render() {
    const { clickMenuOpen } = this.props;
    const { nombre, entidad } = this.state;

    return (
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
        {/* <!-- Sidebar Toggle (Topbar) --> */}
        <button
          onClick={() => {
            clickMenuOpen();
          }}
          id="sidebarToggleTop"
          className="btn btn-link d-md-none rounded-circle mr-3"
        >
          <i className="fa fa-bars"></i>
        </button>

        {/* <!-- Topbar Title --> */}
        <div className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100">
          <div className="font-weight-bold text-primary text-uppercase"></div>
        </div>

        {/* <!-- Topbar Navbar --> */}
        <ul className="navbar-nav ml-auto">
          <div className="topbar-divider d-none d-sm-block"></div>

          {/* <!-- Nav Item - User Information --> */}
          <li className="nav-item dropdown no-arrow">
            <a
              className="nav-link dropdown-toggle"
              href="/#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="mr-2 d-none d-lg-inline text-gray-600 text-right small">
                {nombre}
                <br />
                {entidad}
              </span>
              <i className="fas fa-user fa-2x text-gray-300"></i>
            </a>
            {/* <!-- Dropdown - User Information --> */}
            <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
              style={{ zIndex: "9999" }}
            >
              <a className="dropdown-item" href="/cic_externo/Usuario/Perfil">
                <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                Perfil
              </a>
              <div className="dropdown-divider"></div>
              <button
                className="dropdown-item"
                onClick={Autenticador.cerrarSesion}
                data-toggle="modal"
                data-target="#logoutModal"
              >
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                Cerrar Sesión
              </button>
            </div>
          </li>
        </ul>
      </nav>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ clickMenuOpen }, dispatch);

const mapStateToProps = (store) => ({
  toggled: store.menuState.menuOpen,
});

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);
